import {
  OrderDirection,
  commonMutationTypes,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";
import { AtsAcLdgr } from "../../supplier/queries/types";

export interface AddItemLdgrAssociByItemResult {
  AddItemLdgrAssociByItem: boolean;
}

export interface AddItemLdgrAssociByItemVar extends commonMutationTypes {
  customer_id: number;
  itemId: number;
  ldgrIds: number[];
}

export interface AtsStckItemLdgrAssoic {
  id: number;
  ldgrStatus: boolean;
  ldgrRemarks: string;
  customerID: number;
  itemID: number;
  ldgrID: number;
  item: {
    id: number;
    desc: string;
    code: string;
    groupDetails: {
      groupName: string;
    };
    categoryDetails: {
      categoryName: string;
    };
    uomDetails: {
      uom: string;
    };
    ldgr_count: number;
  };
  ldgr: AtsAcLdgr;
}

export interface AtsStckItemLdgrAssoicEdge {
  node: AtsStckItemLdgrAssoic;
  cursor: string;
}

export interface AtsStckItemLdgrAssoicConnection {
  edges: AtsStckItemLdgrAssoicEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetStckItemLdgrAssociDetailsResult {
  GetStckItemLdgrAssociDetails: AtsStckItemLdgrAssoicConnection;
}

export enum ItemLdgrAssoicQueryType {
  BY_ITEM_ID = "BY_ITEM_ID",
  BY_LDGR_ID = "BY_LDGR_ID",
}

export interface itemLdgrAssociData {
  queryType: ItemLdgrAssoicQueryType;
  id: number;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  stckSubCategoryID: number;
}

export enum AtsStckItemLdgrAssoicOrderField {
  LDGR_STATUS = "LDGR_STATUS",
  LDGR_RATING = "LDGR_RATING",
}

export interface GetStckItemLdgrAssociDetailsVar {
  token?: string;
  customer_id: number;
  input: itemLdgrAssociData;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckItemLdgrAssoicOrderField;
  };
  name: string;
}

export interface DeleteItemLdgrAssociByItemResult {
  DeleteItemLdgrAssociByItem: boolean;
}

export interface DeleteItemLdgrAssociByItemVar extends commonMutationTypes {
  customer_id: number;
  itemId: number;
  ldgrIds: number[];
}
